import React from "react";
import { Flame } from "lucide-react";
import { Card } from "../core/Layout";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function BookingHeatmap({ data }: { data?: number[][] }) {
  const max = Math.max(1, ...(data || []).flat());
  return (
    <Card title="Peak demand · weekday × hour" icon={Flame} testId="booking-heatmap">
      <p className="mb-3 text-xs text-slate-500">Booked vehicle-hours in the selected period (Malaysia time). Darker = more vehicles out.</p>
      <div className="overflow-x-auto">
        <div className="grid min-w-[640px] gap-[3px]" style={{ gridTemplateColumns: "2.5rem repeat(24, minmax(0, 1fr))" }}>
          <span />
          {Array.from({ length: 24 }, (_, h) => <span key={h} className="text-center text-[9px] text-slate-400">{h % 3 === 0 ? `${String(h).padStart(2, "0")}` : ""}</span>)}
          {DAYS.map((d, di) => (
            <React.Fragment key={d}>
              <span className="text-[10px] font-semibold text-slate-500">{d}</span>
              {Array.from({ length: 24 }, (_, h) => {
                const v = data?.[di]?.[h] || 0;
                const a = v ? 0.15 + 0.85 * (v / max) : 0;
                return <span key={h} title={`${d} ${String(h).padStart(2, "0")}:00 · ${v} vehicle-hour(s)`} data-testid={`heat-${di}-${h}`} className="aspect-square rounded-[3px] bg-slate-100" style={a ? { background: `color-mix(in srgb, var(--brand) ${Math.round(a * 100)}%, white)` } : undefined} />;
              })}
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="mt-2 flex items-center justify-end gap-1 text-[10px] text-slate-400">Less {[0.15, 0.4, 0.7, 1].map((a) => <span key={a} className="h-3 w-3 rounded-[3px]" style={{ background: `color-mix(in srgb, var(--brand) ${Math.round(a * 100)}%, white)` }} />)} More</div>
    </Card>
  );
}
